<div class="modal-overlay w-full flex flex-wrap h-full w-full">

    <div class="left-gallery-view w-[45%] h-[92%] pl-5 pt-5 flex gap-5 flex-wrap">
        <div class="header w-full text-lg font-medium font-inter text-gray-900">Gallery</div>
        <div class="tabs flex justify-start items-center gap-4 border-b-2 border-gray-200 w-full">
            <span *ngFor="let tab of TabsArray"
                class="cursor-pointer text-sm font-semibold font-inter  pb-[12px] px-[8px]" [ngClass]="activeTab === tab.value
      ? 'bg-purple-50 text-purple-brand border-b-2 border-purple-600' : 'text-gray-500'"
                (click)="onTabChange(tab.value)">
                {{tab?.display}}
            </span>
        </div>

        <div class="images-container !overflow-y-auto h-[87%] w-full flex gap-2 flex-wrap">
            <div *ngFor="let image of galleryImages; index as i;" (click)="onImageChange(i)"
                class="image-container w-[48%] rounded-lg {{activeImageIndx === i ? 'shadow-sm border-2 border-purple-600 p-1' : '' }}">
                <img [src]="image['src']" class="rounded-md w-full h-[100px] object-cover" />
            </div>
        </div>

    </div>



    <div class="relative right-image-preview w-[55%] bg-black h-full flex items-center">

        <!-- Left Arrow -->
        <span class=" absolute z-index-900 left-1 rounded-3xl p-2 mr-[1.5rem] {{activeImageIndx === 0 ? 'bg-white/50 pointer-events-none' : 'cursor-pointer bg-white'}}" (click)="prevImg()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
        </span>

        <img [src]="galleryImages[activeImageIndx]['src']" class="w-full h-[70%] object-cover " />

        <!-- Right Arrow -->
        <span class="absolute z-index-900 right-1  rounded-3xl p-2 !ml-[1.5rem]  {{activeImageIndx === (galleryImages.length - 1) ? 'bg-white/50 pointer-events-none' : 'cursor-pointer bg-white'}}" (click)="nextImg()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
        </span>

    </div>



</div>